import { useQuery } from "@tanstack/react-query";
import { meApi } from "@/api/me";

export function useMe() {
  return useQuery({
    queryKey: ["me"],
    queryFn: () => meApi.getMe(),
    staleTime: 60_000,
  });
}
